const headers = [
  {
    text: 'sale.sale_status',
    value: 'isEnabled',
    sortable: true,
    width: '8%',
    align: 'center'
  },
  {
    text: 'storage.storage_storage-move-reason',
    value: 'name',
    sortable: true,
    width: '82%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: true,
    width: '9%'
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '9%'
  }
]
export default { headers }
